<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-warning-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M45 24c0 11.598-9.402 21-21 21S3 35.598 3 24 12.402 3 24 3s21 9.402 21 21zm-18.323 6.825c0-.644-.522-1.166-1.166-1.166h-3.034c-.644 0-1.166.522-1.166 1.166v3.034c0 .644.522 1.166 1.166 1.166h3.034c.644 0 1.166-.522 1.166-1.166v-3.034zm0-17.134c0-.645-.522-1.167-1.166-1.167h-3.034c-.644 0-1.166.522-1.166 1.167v12.273c0 .645.522 1.167 1.166 1.167h3.034c.644 0 1.166-.522 1.166-1.167V13.691z"/></svg>
</template>
<script>

export default {
  name: 'IconWarningFill',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
